"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchPattern = exports.isValidEmail = void 0;
/**
 * From https://stackoverflow.com/a/201378
 * RFC 5322
 * @param {string} input input string to test
 * @returns {boolean} whether or not the input is a validly formatted email.
 */
function isValidEmail(input) {
    if (!input) {
        return false;
    }
    var regex = /^\s*(?:[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])\s*$/;
    return regex.test(input);
}
exports.isValidEmail = isValidEmail;
/**
 * @deprecated This behaves differently on the frontend and backend,
 * and so should be avoided - especially for code which must behave identically in both, like validations.
 * Instead, use the in-built `matches` keyword. For example: `"foo" matches "f.*"`
 *
 * @param string
 * @param pattern
 * @returns
 */
function matchPattern(string, pattern) {
    if (string && pattern) {
        return new RegExp(pattern).test(string);
    }
    return true;
}
exports.matchPattern = matchPattern;
//# sourceMappingURL=string.js.map